import {
  Component,
  ComponentRef,
  EventEmitter,
  Inject,
  Input, OnChanges,
  OnInit,
  Output, PLATFORM_ID,
  SimpleChanges,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {GPX, LatLngCustom} from "../leaflet-maps/gpx-layer";
import {Country, Lookups, Waypoint} from "@model";
import {LatLng} from "leaflet";
import {isPlatformBrowser} from "@angular/common";
import {LeafletMapsComponent} from "../leaflet-maps/leaflet-maps.component";

@Component({
  selector: 'app-leaflet-maps-wrapper',
  templateUrl: './leaflet-maps-wrapper.component.html',
  styleUrl: './leaflet-maps-wrapper.component.scss'
})
export class LeafletMapsWrapperComponent implements OnInit, OnChanges {
  @ViewChild("container", {read: ViewContainerRef}) container?: ViewContainerRef;

  @Input() gpx?: GPX
  @Input() lat?: number;
  @Input() lng?: number;
  @Input() isPointSelectionEnabled: boolean = false;
  @Input() points: Array<Waypoint> = [];
  @Input() currentlyEditingPoint?: Waypoint;
  @Input() isShowLocationMarkerEnabled: boolean = false;
  @Input() isGetLocationEnabled: boolean = false;
  @Input() isEraseLocationEnabled: boolean = false;
  @Input() positionAbsolute: boolean = false;
  @Input() defaultLanguage?: number | undefined;
  @Input({required: true}) languages: Lookups[] = [];
  @Input() countries: Country[] = [];
  @Input() defaultLanguageCode: string | undefined;
  @Input() mapOnEventCalendar: boolean = false;
  @Input() increaseMapHeight: boolean = false;

  @Output() onSelectLocation: EventEmitter<LatLng> = new EventEmitter();
  @Output() onEraseLocation: EventEmitter<void> = new EventEmitter();
  @Output() onSelectPoint: EventEmitter<LatLngCustom> = new EventEmitter();

  private componentInstance?: LeafletMapsComponent;

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      import("../leaflet-maps/leaflet-maps.component").then(({LeafletMapsComponent}) => {
        const componentRef: ComponentRef<LeafletMapsComponent> = this.container!.createComponent(LeafletMapsComponent);
        this.componentInstance = componentRef.instance;
        this.componentInstance.gpx = this.gpx;
        this.componentInstance.lat = this.lat;
        this.componentInstance.lng = this.lng;
        this.componentInstance.isPointSelectionEnabled = this.isPointSelectionEnabled;
        this.componentInstance.points = this.points;
        this.componentInstance.currentlyEditingPoint = this.currentlyEditingPoint;
        this.componentInstance.isShowLocationMarkerEnabled = this.isShowLocationMarkerEnabled;
        this.componentInstance.isGetLocationEnabled = this.isGetLocationEnabled;
        this.componentInstance.isEraseLocationEnabled = this.isEraseLocationEnabled;
        this.componentInstance.positionAbsolute = this.positionAbsolute;
        this.componentInstance.defaultLanguage = this.defaultLanguage;
        this.componentInstance.languages = this.languages;
        this.componentInstance.countries = this.countries;
        this.componentInstance.defaultLanguageCode = this.defaultLanguageCode;
        this.componentInstance.mapOnEventCalendar = this.mapOnEventCalendar;
        this.componentInstance.increaseMapHeight = this.increaseMapHeight;
        this.componentInstance.onSelectLocation = this.onSelectLocation;
        this.componentInstance.onEraseLocation = this.onEraseLocation;
        this.componentInstance.onSelectPoint = this.onSelectPoint;
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (isPlatformBrowser(this.platformId) && this.componentInstance) {
      this.componentInstance.gpx = this.gpx;
      this.componentInstance.lat = this.lat;
      this.componentInstance.lng = this.lng;
      this.componentInstance.isPointSelectionEnabled = this.isPointSelectionEnabled;
      this.componentInstance.points = this.points;
      this.componentInstance.currentlyEditingPoint = this.currentlyEditingPoint;
      this.componentInstance.isShowLocationMarkerEnabled = this.isShowLocationMarkerEnabled;
      this.componentInstance.isGetLocationEnabled = this.isGetLocationEnabled;
      this.componentInstance.isEraseLocationEnabled = this.isEraseLocationEnabled;
      this.componentInstance.positionAbsolute = this.positionAbsolute;
      this.componentInstance.defaultLanguage = this.defaultLanguage;
      this.componentInstance.languages = this.languages;
      this.componentInstance.countries = this.countries;
      this.componentInstance.defaultLanguageCode = this.defaultLanguageCode;
      this.componentInstance.mapOnEventCalendar = this.mapOnEventCalendar;
      this.componentInstance.increaseMapHeight = this.increaseMapHeight;
      this.componentInstance.ngOnChanges(changes);
    }
  }
}
